import { V2ChatMessage } from '../types/v2';

export type ClientSupportMessageAction = 'copy' | 'edit' | 'delete' | 'history';

export const getClientSupportMessageActions = (
  message: V2ChatMessage,
): ClientSupportMessageAction[] => {
  const actions: ClientSupportMessageAction[] = [];
  if (message.content) actions.push('copy');
  if (message.sender_type === 'admin' && !message.deleted_at) {
    actions.push('edit', 'delete');
  }
  if (message.edited_at || message.deleted_at) actions.push('history');
  return actions;
};

export const combineSupportUnreadCounts = (personal: number, clients: number): number =>
  Math.max(0, personal) + Math.max(0, clients);
